import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className='bg-gray-900 text-white py-8 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-6xl mx-auto'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          {/* Company Info */}
          <div className='space-y-4'>
            <h3 className='text-lg font-semibold'>PCSO E-Lotto</h3>
            <p className='text-gray-300 text-sm leading-relaxed'>
              The official online platform for PCSO lottery games. Play
              responsibly and support charitable causes across the Philippines.
            </p>
            <div className='text-gray-300 text-sm'>
              <p>PCSO Main Office</p>
              <p>E. Rodriguez Jr. Ave, Quezon City</p>
              <p>Metro Manila, Philippines</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className='space-y-4'>
            <h3 className='text-lg font-semibold'>Quick Links</h3>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link
                  to='/home'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to='/about'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to='/play-game'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Play Games
                </Link>
              </li>
              <li>
                <Link
                  to='/game-results'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Game Results
                </Link>
              </li>
              <li>
                <Link
                  to='/promotions'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Promotions
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className='space-y-4'>
            <h3 className='text-lg font-semibold'>Support</h3>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link
                  to='/contact'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <a
                  href='mailto:support@pcsoe-lotto.com'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Email Support
                </a>
              </li>
              <li>
                <a
                  href='tel:+632-8523-8888'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Phone Support
                </a>
              </li>
              <li>
                <span className='text-gray-300'>24/7 Customer Service</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className='space-y-4'>
            <h3 className='text-lg font-semibold'>Legal</h3>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link
                  to='/privacy-policy'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to='/terms'
                  className='text-gray-300 hover:text-white transition-colors'
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <span className='text-gray-300'>Responsible Gaming</span>
              </li>
              <li>
                <span className='text-gray-300'>Age Restriction: 18+</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='mt-8 pt-8 border-t border-gray-800'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            {/* Copyright */}
            <div className='text-gray-300 text-sm'>
              <p>
                &copy; {new Date().getFullYear()} PCSO E-Lotto. All rights
                reserved.
              </p>
            </div>

            {/* Additional Links */}
            <div className='flex flex-wrap gap-4 text-sm'>
              <Link
                to='/privacy-policy'
                className='text-gray-300 hover:text-white transition-colors'
              >
                Privacy
              </Link>
              <Link
                to='/terms'
                className='text-gray-300 hover:text-white transition-colors'
              >
                Terms
              </Link>
              <Link
                to='/about'
                className='text-gray-300 hover:text-white transition-colors'
              >
                About
              </Link>
              <Link
                to='/contact'
                className='text-gray-300 hover:text-white transition-colors'
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Responsible Gaming Notice */}
          <div className='mt-6 p-4 bg-gray-800 rounded-lg'>
            <h4 className='text-yellow-400 font-semibold text-sm mb-2'>
              Responsible Gaming
            </h4>
            <p className='text-gray-300 text-xs leading-relaxed'>
              Gaming should be fun and entertaining. Please play responsibly and
              within your means. If you feel that gaming is becoming a problem,
              please seek help. You must be 18 years or older to participate in
              lottery games.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
